import { render, staticRenderFns } from "./all-order.vue?vue&type=template&id=04aa1a40&scoped=true&"
import script from "./all-order.vue?vue&type=script&lang=js&"
export * from "./all-order.vue?vue&type=script&lang=js&"
import style0 from "./all-order.vue?vue&type=style&index=0&id=04aa1a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aa1a40",
  null
  
)

export default component.exports